export interface Payment {
  createdAt: string;
  updatedAt: string;
  id: string;
  contractorId: string;
  contractorName: string;
  timesheetId: string;
  paymentAmount: number;
  referralBonusAmount: number;
  totalPaymentAmount: number;
  paymentDate: string | null;
  status: string;
  statusDisplay: string;
  paymentMethod: string;
  paymentReference: string | null;
  weekStartDate: string;
  weekEndDate: string;
  facilityName: string;
  retryCount: number;
  maxRetries: number;
  nextRetryAt: string | null;
  failureReason: string | null;
}

export enum BillingStatus {
  PENDING = 'Pending',
  PAID = 'Paid',
  CANCELLED = 'Cancelled',
  APPROVED = 'Approved',
  REJECTED = 'Rejected'
}
